import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  pageTitle: {
    fontSize: 60,
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      marginBottom: 0,
      fontSize: 44,
      fontWeight: 500
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 28,
    }
  },
  titleSubheader: {
    marginBottom: theme.spacing(7.5),
    [theme.breakpoints.down('md')]: {
      display: 'none',
    }
  },
  openPositions: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(3),
    height: theme.spacing(6),
    width: theme.spacing(30),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2),
      width: theme.spacing(24)
    }
  },
  subheaders: {
    textAlign: 'left',
    fontSize: 36,
    [theme.breakpoints.down('md')]: {
      fontSize: 24
    }
  },
  infoText: {
    fontSize: 14,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      fontSize: 16
    }
  },
  guideContainer: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2)
    }
  },
  guideBubbles: {
    height: 64,
    borderRadius: 42.5,
    backgroundColor: '#ffffff',
    padding: theme.spacing(2, 5, 2, 3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  guideText: {
    fontSize: 18,
    color: '#000000',
    fontFamily: theme.gh_vars.circular,
  },
  nameYourJob: {
    backgroundColor: '#e6e6e6',
    borderRadius: 6,
    textAlign: 'center',
    padding: theme.spacing(10, 2.5, 13.25),
    marginLeft: 0,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(0),
      padding: theme.spacing(4, 2.5, 3, 3),
      marginBottom: theme.spacing(2)
    }
  },
  jobDescriptionHeader: {
    color: theme.palette.common.black,
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  jobDescriptionText: {
    color: theme.palette.common.black,
    fontFamily: theme.gh_vars.circular,
  }
}));
